<div
  class="border-standard-outline-light overflow-hidden rounded-lg border bg-white shadow-sm"
  aria-label="Browser-Tab-Vorschau">
  <div class="flex h-11 items-end bg-neutral-200 px-2 pt-2">
    <div
      class="flex h-9 max-w-72 min-w-48 items-center gap-2 rounded-t-lg bg-white px-3 shadow-sm">
      @if (faviconUrl()) {
        <img
          [src]="faviconUrl()"
          alt=""
          class="size-4 shrink-0 object-contain" />
      } @else {
        <span
          class="material-symbols-rounded text-standard-text-secondary !text-lg"
          aria-hidden="true">
          language
        </span>
      }
      <span class="min-w-0 flex-1 truncate text-sm font-medium">
        {{ title() }}
      </span>
      <span
        class="material-symbols-rounded text-standard-text-secondary !text-base"
        aria-hidden="true">
        close
      </span>
    </div>
    <span
      class="material-symbols-rounded text-standard-text-secondary mb-2 ml-2 !text-lg"
      aria-hidden="true">
      add
    </span>
  </div>

  <div class="flex h-12 items-center gap-3 px-3">
    <span
      class="material-symbols-rounded text-standard-text-secondary !text-xl"
      aria-hidden="true">
      arrow_back
    </span>
    <span
      class="material-symbols-rounded text-standard-text-secondary !text-xl"
      aria-hidden="true">
      arrow_forward
    </span>
    <span
      class="material-symbols-rounded text-standard-text-secondary !text-xl"
      aria-hidden="true">
      refresh
    </span>
    <div
      class="border-standard-outline-light text-standard-text-secondary flex h-8 min-w-0 flex-1 items-center gap-2 rounded-full border px-3 text-sm">
      <span class="material-symbols-rounded !text-base" aria-hidden="true">
        search
      </span>
      <span class="truncate">{{ address() }}</span>
    </div>
    <span
      class="material-symbols-rounded text-standard-text-secondary !text-xl"
      aria-hidden="true">
      home
    </span>
  </div>
</div>
